<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">Knowing our customers</TextHeading>
      <TextHeading variant="xl" block>Wild capture seafood</TextHeading>
    </PageHeader>
    <SubMenuMobile/>
    <PageGrid sidebar sharetools>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <ShareLinksArticle desktop></ShareLinksArticle>
        <HeroImage image="cr-wild-capture.jpg"></HeroImage>
        <CardInformation v-for="item in items" v-bind:data="item" v-bind:key="item.id"></CardInformation>
        <ShareLinksArticle mobile></ShareLinksArticle>
      </PageMain>
    </PageGrid>
    <FooterInfo></FooterInfo>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import FooterInfo from '../components/FooterInfo.vue'
import PageMain from '../elements/PageMain.vue'
import HeroImage from '../components/HeroImage.vue'
import ShareLinksArticle from '../components/ShareLinksArticle.vue'
import CardDownload from '../components/CardDownload.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
import CardInformation from '../components/CardInformation.vue'
export default {
  name: 'SeafoodWildCapture',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    ShareLinksArticle,
    HeroImage,
    PageMain,
    FooterInfo,
    TheFooter,
    CardInformation
  },
  data() {
    return {
      items: [
        {
          image: require('@/assets/images/logos/logo-responsibly-sourced.png'),
          title:
            'This is the harvesting of naturally occurring fish and seafood in marine and freshwater environments. Our range of wild capture seafood covers more than 50+ species each of which can be found either in store or as part of our customer order at fish bar service.',
          text:
            'A large number of the species that we stock are sourced from the productive mixed species fishery in the South West of England which includes scallops, sprats, gurnard, pouting and four species of ray.'
        },
        {
          image: require('@/assets/images/logos/logo-sfp.png'),
          title: 'Sustainable Fisheries Partnership',
          text:
            'We partner with the Sustainable Fisheries Partnership (SFP) who helps to inform us in our seafood source risk assessments.<br/><br>Where issues are identified we work with our suppliers to address them and details of our source fisheries, their issues and a full summary of what Morrisons is doing can be found in our Ocean Disclosure Project first published in 2015 based on what we bought in 2014',
          button: 'Visit the Ocean Disclosure website'
        },
        {
          image: require('@/assets/images/logos/logo-issf.png'),
          title: 'Morrisons Tuna Policy',
          text:
            'Our tuna policy is also to only buy from pole and line vessels or from fishing methods that do not rely on the use of Fishery Aggregation Devices (FADs). Tuna, unlike some of our other seafood species, is highly migratory, managed on a regional level and a relatively expensive commodity.<br/><br/>For these reasons alone tuna supply chains are at high risk of illegal, unregulated and unreported (IUU) fishing which not only leaves the species at risk of over fishing but also removes livelihood from legitimate fishers.<br/><br/>Our ambition is that all of our tuna supply vessels are independently assessed and listed on the Proactive Vessel Register which is an initiative of the International Seafood Sustainability Foundation (ISSF) and audits the legal compliance of tuna fishing vessels.',
          button: 'Visit the ISSF website'
        },
        {
          image: require('@/assets/images/logos/logo-seafish.png'),
          title: 'Seafish Industry Authority',
          text:
            'Due to the large range of species that we purchase from the South West of England we have a number of species that some do not believe are "sustainable".<br/><br/>Not being sustainable is in many cases purely due to a lack of scientific knowledge and data being available on which to make an informed scientific decision.<br/><br/>Factors influencing this are generally economic and to address this scenario we have worked with our suppliers and Seafish Industry Authority to carry out an Ecological Risk Based Analysis of them.',
          button: 'Visit the Seafish website',
          extra:
            'This approach allows us to base the impacts of the fishing activity in the area we buy from on the overall fish stock to inform what steps need to be taken.<br/><br/>By continuing to buy these species we are able to support the local fishing industry to fill the data gaps to remove the "unsustainable" label whilst also providing species to our customer which others might not choose to stock.'
        }
      ]
    }
  }
}
</script>
